import "./doctors-components.css";
import { BsFillArrowLeftCircleFill } from "react-icons/bs";
import docItem from "../../images/doctors/person-doc.jpg";
import { Link } from "react-router-dom";
import { CiLocationOn } from "react-icons/ci";
import { FcDepartment } from "react-icons/fc";
import { FaMobile, FaLocationDot, FaClock } from "react-icons/fa6";
import { MdOutlineTitle } from "react-icons/md";
import { FaPhone } from "react-icons/fa";

const DoctorItem = ({ doctor, username, userId }) => {
  const profileLink = userId
    ? `/profile/${userId}`
    : `/profile/${doctor?.user?._id}`;
  return (
    <>
      <div className="doctor-item-container">
        <img src={docItem} alt="img" />
        <div className="doctor-item-info">
          <h5 title={doctor?.name} className="doctor-item-name">
            {doctor?.name.substr(0, 25)}{" "}
          </h5>
          <div className="doctor-item-department">
            <div title={doctor?.city} className="city">
              <CiLocationOn className="ms-2" color="#014160" size={18} />
              {doctor?.city?.substr(0, 15)}
            </div>
            <div title={doctor?.department} className="dept">
              <FcDepartment className="ms-2" color="#014160" size={16} />
              {doctor?.department?.substr(0, 20)}
            </div>
          </div>
          <div title={doctor?.title} className="doctor-item-title">
            <MdOutlineTitle className="ms-2" color="#014160" size={16} />
            {doctor?.title?.substr(0, 35)}
          </div>
          <div title={doctor?.mobile} className="doctor-item-mobile">
            <FaMobile className="ms-2" color="#014160" size={16} />
            {doctor?.mobile?.substr(0, 11)}
          </div>
          <div title={doctor?.tell} className="doctor-item-tell">
            <FaPhone className="ms-2" color="#014160" size={16} />
            {doctor?.tell?.substr(0, 10)}
          </div>
          <div title={doctor?.address} className="doctor-item-address">
            <FaLocationDot className="ms-2" color="#014160" size={16} />
            {doctor?.address?.substr(0, 30)}
          </div>
          <div title={doctor?.workingDay} className="doctor-item-workingDay">
            <FaClock className="ms-2" color="#014160" size={14} />
            {doctor?.workingDay?.substr(0, 30)}
          </div>
          <div className="link-wrapper">
            <div className="author">
              <span>اضافهُ: </span>
              <Link className="author" to={profileLink}>
                {username
                  ? username.substr(0, 25)
                  : doctor?.user?.username?.substr(0, 25)}
              </Link>
            </div>
            <Link className="details" to={`/doctors/details/${doctor?._id}`}>
              <BsFillArrowLeftCircleFill />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorItem;
